<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>
export default {
  name: 'App',
  computed: {
    lang() {
      return this.$i18n.locale
    }
  },
  metaInfo () {
    return {
      htmlAttrs: {
        lang: this.lang
      },
      title: 'WEG Fashion group',
      link: [
        {'rel': 'stylesheet', 'href': 'https://fonts.googleapis.com/css?family=Montserrat:400,700|Playfair+Display'}
      ]
    }
  }
}
</script>
<style lang="scss">
html, body, #app {
  min-height: 100%;
}
#app  > /deep/ div {
  min-height: 100%;
}
#app {
  font-family: $font-family-sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1,
h2,
h3,
h4,
h5,
.title {
  font-family: $headings-font-family;
}

</style>
